<template>
  <div class="error-container">
    <div class="error-wrapper">
      <span class="error-text">
        404: Unable to fetch user data
      </span>
      <ul style="list-style-type:none; text-align: start;">
        <li>
          <span>1. First make sure you have joined your account in the #start-here channel within the Discord server</span>
        </li>
        <li>
          <span>2. Inside #start-here channel, enter your email by typing !join example@email.com</span>
        </li>
        <li>
          <span>3. Done correctly you should receive a success message from @Dashboard Auth</span>
        </li>
        <li>
          <span>4. After completing these steps, come back to this url, refresh, and you will be able to manage your subscription via the dashboard</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  props: {
    discord: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
  .error-container {
    height: 400px;
    width: 400px;
    background-color: #282b2f;
    border-radius: 8px;
    color: #f8f8f8;
    margin: 0 auto;
    box-shadow: 1px 1px 0px #2f3033,
                2px 2px 0px #282b2f,
                3px 3px 0px #2f3033,
                4px 4px 0px #282b2f,
                5px 5px 0px #2f3033,
                6px 6px 0px #282b2f;
    display: flex;
    align-items: center;
  }

  .error-wrapper {
    margin: 0 auto;
    text-align: center;
    padding-right: 20px;
    padding-left: 20px;
  }

  .error-text {
    font-weight: 800;
    text-transform: uppercase;
  }
</style>